import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import {
    Container,
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap";

import PresentationHeader from "components/Headers/PresentationHeader2.js";

function Diagnostico() {
    // const [iconTabs, setIconTabs] = React.useState("1");
    // const [Modal3, setModal3] = React.useState(false);
    // const [tooltipOpen, setTooltipOpen] = useState(false);
    // const toggle = () => setTooltipOpen(!tooltipOpen);

    React.useEffect(() => {
        document.body.classList.add("presentation-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        // initialise Rellax for this page
        if (window.innerWidth >= 991) {
            setTimeout(function () {
                new Rellax(".rellax", {
                    center: true,
                });
            }, 5000);
            new Rellax(".rellax-header");
            new Rellax(".rellax-text");
        }

        // we need to add a script for the github buttons
        let script = document.createElement("script");
        script.src = "https://buttons.github.io/buttons.js";
        script.id = "github-buttons-script-id";
        document.body.appendChild(script);

        return function cleanup() {
            document.body.classList.remove("tramites-page");
            document.body.classList.remove("sidebar-collapse");

            // we need to remove the script when we change the page
            script.parentNode.removeChild(script);
        };
    });
    return (
        <>
            <Container className="fluid">
                <PresentationHeader titulo="Consulta Ciudadana"/>
                <Row className="justify-content-center">
                    <Col md="10">
                        <Card>
                            <CardBody>
                                <p className="text-justify" style={{ fontSize: "14px", color:"#68696F", fontFamily:"serif" }}>
                                    <b>La consulta a la ciudadanía</b> es un mecanismo de participación que busca conocer las opiniones, sugerencias 
                                    o propuestas, comentarios y aportes de los usuarios, ciudadanos y grupos de interés con respecto a los proyectos, 
                                    normas, políticas, programas o trámites adelantados por la entidad antes de la formulación de los mismos o la toma 
                                    de decisiones. Este mecanismo, sirve para priorizar problemáticas o temas en rendición de cuentas, seleccionar o 
                                    evaluar programas, obras o proyectos de inversión en cualquier momento del ciclo de la gestión pública y para la 
                                    mejora de trámites y disposiciones legales.*
                                    <br></br>
                                    <br></br>
                                    <a href="https://www.funcionpublica.gov.co/inicio?p_p_state=maximized&p_p_mode=view&saveLastPath=false&_com_liferay_login_web_portlet_LoginPortlet_mvcRenderCommandName=%2Flogin%2Flogin&p_p_id=com_liferay_login_web_portlet_LoginPortlet&p_p_lifecycle=0&_com_liferay_login_web_portlet_LoginPortlet_redirect=%2Fdocuments%2F">
                                        <b style={{ color: '#045FB4' }}>
                                        * Departamento Administrativo de la Función Pública (2021). Lineamientos para publicar información en el menú participa sobre participación ciudadana en la gestión pública. Obtenido de: https://www.funcionpublica.gov.co/documents/
                                        </b>
                                    </a>
                                </p>
                                <center>
                                    <a type="button" href={"https://drive.google.com/file/d/1RvhHAoEJE2ARw1E-n9o5GdwUKkj6G5h8/view?usp=sharing"} style={{ borderBottom: "none" }} target="_black">
                                        <img
                                            alt="Imagen con referencia hacia un icono para descargar un archivo en PDF"
                                            width="80px"
                                            src={require("assets/img/Notaria/PDF.png")}
                                        ></img>
                                        <h6 className="texto">Contenido Consulta Ciudadana</h6>
                                    </a>
                                    <br></br>
                                </center>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Diagnostico;